import { useEffect, useState } from "react";
import AnimatedPage from "../components/animatedPage"
import Banner from "../components/ourPeople/banner"
import Peoples from "../components/ourPeople/peoples"
import { useDispatch, useSelector } from "react-redux";
import { fetchOurPeopleData } from "../redux/slice/ourPeoplePage";
const OurPeoples = () => {

    const dispatch = useDispatch()
    useEffect(() => {
        dispatch(fetchOurPeopleData("/our-leaders"))
    }, [dispatch])
    const state = useSelector(state => state.ourPeople)


    const ourPeople = state?.data?.properties

    const [selectedOption, setSelectedOption] = useState("");
    const [search,setSearch] = useState("")
        const tags = ourPeople?.searchTags?.items != null ?
        ourPeople?.searchTags?.items?.map(item =>
            item?.content?.properties?.tags !== null ? item?.content?.properties?.tags : ""
        ).flat() : ""
    const options = tags != "" ? tags?.filter(itemTag => itemTag !== 'UNITEN International Advisory Council' && itemTag !== 'ad'): null;

    useEffect(() => {
        setSelectedOption(options ? options[0] : "");
    }, [ourPeople?.searchTags?.items])

    return (
        <AnimatedPage>
            {/* <ScrollToTop/> */}
            <Banner ourPeople={ourPeople} search={search} handleSearch={setSearch} handleTagSelected={setSelectedOption} />
            <Peoples search={search} tag={selectedOption} />
        </AnimatedPage>
    )
}

export default OurPeoples